import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Modal from '../modal';
import { selectRole, getUserDetails, logout, submitTermsAgreement, getUserProfile, unsetImpersonateRole } from './../../reducers/identity';
import { setRoleSelectorVisibility } from '../../reducers/dialogs';
import { setTenant } from '../../reducers/tenants';
import RoleSelectorList from './components/roleList';
import RoleSelectorTermsAgreement from './components/termsAgreement';
import ImpersonateAgreement from './components/impersonateAgreement';

import './roleSelector.css';
import { history } from '../../configuration/store';

class ConnectedRoleSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            agreement: undefined
        };

        this.getModalData = this.getModalData.bind(this);
        this.getImpersonateModalData = this.getImpersonateModalData.bind(this);

        this.applyRoleSelection = this.applyRoleSelection.bind(this);
        this.setRoleForAgreement = this.setRoleForAgreement.bind(this);
    }

    setRoleForAgreement(role, onComplete = () => null) {
        this.setState({ ...this.state, agreement: role }, onComplete);
    }

    applyRoleSelection(role, onComplete = () => null) {
        const { user, impersonatedUser, selectRole, getUserDetails, getUserProfile, setTenant, cancelImpersonate } = this.props;
        const userId = impersonatedUser && !cancelImpersonate ? impersonatedUser.id : user.sub;
        getUserDetails(role, () => {
            getUserProfile(userId, () => {
                setTenant(role, () => {
                    selectRole(role, onComplete);
                });
            });
        });
    }

    getModalData() {
        const { user, roles, logout, submitTermsAgreement } = this.props;
        const { agreement } = this.state;
        if (agreement) {
            return {
                content: (
                    <RoleSelectorTermsAgreement
                        back={() => this.setRoleForAgreement()}
                        onSubmit={() => submitTermsAgreement(user, agreement, result => this.applyRoleSelection(result))}
                    />
                ),
                title: <FormattedMessage id={'chooseRole.TermsAgreement'} defaultMessage={'Terms Agreement'} />
            };
        }

        return {
            content: <RoleSelectorList roles={roles} onRoleSelected={role => this.applyRoleSelection(role)} logout={logout} showLogout={false} />,
            title:
                roles && roles.length > 0 ? (
                    <FormattedMessage id={'chooseRole.title'} defaultMessage={'Profile selection'} />
                ) : (
                    <FormattedMessage id={'noRoleFound.title'} defaultMessage={'Oh no!'} />
                )
        };
    }

    getImpersonateModalData() {
        const { roles, impersonateRole, setRoleSelectorVisibility, cancelImpersonate, unsetImpersonateRole } = this.props;
        const action = cancel => {
            return cancel
                ? () => unsetImpersonateRole(() => this.applyRoleSelection(roles[0]))
                : () => {
                      history.push('/blank');
                      this.applyRoleSelection(impersonateRole, () => history.push('/'));
                  };
        };

        return {
            content: (
                <ImpersonateAgreement
                    role={impersonateRole}
                    onSubmit={action(cancelImpersonate)}
                    cancel={() => setRoleSelectorVisibility(false)}
                    exiting={cancelImpersonate}
                />
            )
        };
    }

    render() {
        const { visible, setRoleSelectorVisibility, impersonateRole } = this.props;
        let { title, content } = impersonateRole ? this.getImpersonateModalData() : this.getModalData();

        return (
            <Modal size="col-xs-12 col-md-4 col-md-offset-4" title={title} open={visible} onClose={() => setRoleSelectorVisibility(false)}>
                {content}
            </Modal>
        );
    }
}

ConnectedRoleSelector.defaultProps = {
    roles: []
};

ConnectedRoleSelector.propTypes = {
    roles: PropTypes.array
};

const mapStateToProps = state => ({
    role: state.identity.role,
    user: state.identity.user,
    roles: state.identity.roles,
    visible: state.dialogs && state.dialogs.roleSelectorVisible,
    impersonateRole: state.dialogs.impersonateRole,
    impersonatedUser: state.identity.impersonatedUser,
    cancelImpersonate: state.dialogs.cancelImpersonate
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            selectRole,
            logout,
            getUserDetails,
            getUserProfile,
            setRoleSelectorVisibility,
            submitTermsAgreement,
            setTenant,
            unsetImpersonateRole
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedRoleSelector);



// WEBPACK FOOTER //
// ./src/components/roleSelector/connected.jsx